import { css, keyframes } from '@emotion/react';

export type AnimationType =
  | 'zoomIn'
  | 'zoomOut'
  | 'slideUpIn'
  | 'slideUpOut'
  | 'slideRightIn'
  | 'slideRightOut'
  | 'slideUpFadeIn'
  | 'slideUpFadeOut'
  | 'showMessage'
  | 'fadeIn'
  | 'fadeOut';

export const animations = css`
  @keyframes zoomIn {
    from {
      opacity: 0;
      visibility: hidden;
      transform: scale3d(0.3, 0.3, 0.3);
    }

    to {
      opacity: 1;
      visibility: visible;
    }
  }

  @keyframes zoomOut {
    from {
      opacity: 1;
      visibility: visible;
      transform: scale3d(1.1, 1.1, 1.1);
    }

    to {
      opacity: 0;
      visibility: hidden;
      transform: scale3d(0.3, 0.3, 0.3);
    }
  }

  @keyframes slideUpIn {
    from {
      transform: translate3d(0, 100%, 0);
    }

    to {
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes slideUpOut {
    from {
      transform: translate3d(0, 0, 0);
    }

    to {
      transform: translate3d(0, 150%, 0);
    }
  }

  @keyframes slideRightIn {
    from {
      transform: translate3d(100%, 0, 0);
    }

    to {
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes slideRightOut {
    from {
      transform: translate3d(0, 0, 0);
    }

    to {
      transform: translate3d(100%, 0, 0);
    }
  }

  @keyframes slideUpFadeIn {
    from {
      opacity: 0;
      visibility: hidden;
      transform: translate3d(0, 50%, 0);
    }

    to {
      opacity: 1;
      visibility: visible;
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes slideUpFadeOut {
    from {
      opacity: 1;
      visibility: visible;
      transform: translate3d(0, 0, 0);
    }

    to {
      opacity: 0;
      visibility: hidden;
      transform: translate3d(0, 50%, 0);
    }
  }

  @keyframes showMessage {
    from {
      opacity: 0;
      transform: translateY(10px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
      visibility: visible;
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
      visibility: hidden;
    }
  }
`;

export const fadeInDown = ({ maxHeight = 0 } = {}) => keyframes`
  from {
    opacity: 0;
    visibility: hidden;
    transform: translate3d(0, -40px, 0);
    ${Boolean(maxHeight) && `max-height: 0`};
  }

  to {
    opacity: 1;
    visibility: visible;
    transform: translate3d(0, 0, 0);
    ${Boolean(maxHeight) && `max-height: ${maxHeight}px`};
  }
`;

export const fadeOutUp = ({ maxHeight = 0 } = {}) => keyframes`
  from {
    opacity: 1;
    visibility: visible;
    transform: translate3d(0, 0, 0);
    ${Boolean(maxHeight) && `max-height: ${maxHeight}px`};
  }

  to {
    opacity: 0;
    visibility: hidden;
    transform: translate3d(0, -40px, 0);
    ${Boolean(maxHeight) && `max-height: 0`};
  }
`;
